export const Layout = () => import('@/layout/index.vue')
import { getRouteRoles } from '@/utils/index'

/**
 * 设置管理路由
 */
const routes = {
  path: '/setting',
  redirect: 'noRedirect',
  component: Layout,
  meta: {
    icon: 'Setting',
    title: '设置管理',
    roles: [],
    activeMenuTop: '/setting',
    hidden: false,
    keepAlive: true,
    alwaysShow: false
  },
  children: [
    {
      path: 'setting',
      name: 'SettingSetting',
      component: () => import('@/views/setting/setting/setting.vue'),
      meta: {
        icon: 'Setting',
        title: '设置管理',
        roles: ['admin/setting.Setting/basicInfo', 'admin/setting.Setting/contactInfo'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    },
    {
      path: 'file',
      name: 'FileSetting',
      component: () => import('@/views/file/setting/setting.vue'),
      meta: {
        icon: 'Files',
        title: '文件设置',
        roles: ['admin/file.Setting/basicInfo', 'admin/file.Setting/limitInfo', 'admin/file.Setting/apiInfo'],
        activeMenuTop: '/setting',
        hidden: false,
        keepAlive: true,
        alwaysShow: false
      }
    }
  ]
}

routes.meta.roles = getRouteRoles(routes)

export default routes
